// extracted by mini-css-extract-plugin
module.exports = {"input":"Search_input__3iTQH","btn":"Search_btn__VNvBO"};